import { useState } from 'react';

export default function useMonthWalker() {
  const today = new Date();
  const baseYear = today.getFullYear();
  const baseMonth = today.getMonth();

  const [offset, setOffset] = useState(0); 

  const absoluteMonth = baseMonth + offset;
  const currentMonth = absoluteMonth % 12;
  const currentYear = baseYear + Math.floor(absoluteMonth / 12);

  const nextMonth = () => {
    if (offset < 2) setOffset(offset + 1);
  };

  const prevMonth = () => {
    if (offset > 0) setOffset(offset - 1);
  };

  return {
    year: currentYear,
    month: currentMonth,
    offset,
    nextMonth,
    prevMonth,
    isCalendarStart: offset === 0,
    isCalendarEnd: offset === 2,
  };
}
